// const obj = { name: 'obj' };
// const obj2 = { name: 'obj2' };
// export default { obj, obj2 };

export const QueryType_Index_1_BannerImage="QueryType_Index_1_BannerImage";
export const QueryType_Index_2_Team="QueryType_Index_2_Team";
export const QueryType_Index_3_Op="QueryType_Index_3_Op";
export const QueryType_Index_4_Action="QueryType_Index_4_Action";
export const QueryType_Index_5_3482="QueryType_Index_5_3482";
export const QueryType_Index_6_Images="QueryType_Index_6_Images";
export const QueryType_Index_7_Videos="QueryType_Index_7_Videos";

export const QueryType_Menu="QueryType_Menu";
export const QueryType_Setting="QueryType_Setting";
export const QueryType_Years="QueryType_Years";
export const QueryType_Content="QueryType_Content";
export const QueryType_Block="QueryType_Block";
// // export const QueryType_MenuTop="QueryType_MenuTop";
// // export const QueryType_MenuLeft="QueryType_MenuLeft";
//
// // var testValue="abc";
// export default const variable = 'value';
//
// export default {
//     // var testValue2="abc";
//
//     test(){
//
//     }
//     // QueryType_Index_1_BannerImage
//     // QueryType_Index_2_Team
//     // export const QueryType_Index_1_BannerImage="QueryType_Index_1_BannerImage";
//     // export const QueryType_Index_2_Team="QueryType_Index_2_Team";
//     // export const QueryType_Index_3_Op="QueryType_Index_3_Op";
//     // export const QueryType_Index_4_Action="QueryType_Index_4_Action";
//     // export const QueryType_Index_5_3482="QueryType_Index_5_3482";
//     // export const QueryType_Index_6_Images="QueryType_Index_6_Images";
//     // export const QueryType_Index_7_Videos="QueryType_Index_7_Videos";
//     //
//     // export const QueryType_Menu="QueryType_Menu";
// }
